export default "__VITE_ASSET__CT9H49MF__"